import { render, staticRenderFns } from "./answerList.vue?vue&type=template&id=4e068340&scoped=true"
import script from "./answerList.vue?vue&type=script&lang=js"
export * from "./answerList.vue?vue&type=script&lang=js"
import style0 from "./answerList.vue?vue&type=style&index=0&id=4e068340&prod&lang=scss&scoped=true"
import style1 from "./answerList.vue?vue&type=style&index=1&id=4e068340&prod&lang=css"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e068340",
  null
  
)

export default component.exports